import '../../styles/bookSearch.css';
import { FaRegTimesCircle } from "react-icons/fa";
import { useState, useEffect } from 'react';
import {doc, collection, updateDoc,getDoc} from 'firebase/firestore';
import { useAuthState } from "react-firebase-hooks/auth";
import { auth, db } from "../../firebase.js";

export const BookListPrivacy = ({onClose,docID,privacy}) =>{
    const [user] = useAuthState(auth);
    const [makeItPrivate, setMakePrivate] = useState(null);
    // const [makeItPublic, setMakePublic] = useState(null);

    useEffect(() => {
        
        
        const UpdateBookListVisibility= async() =>{
            if (makeItPrivate === true) {
                const uid = user.uid;
                try{
                  const subcollectionRef = collection(db, "users", uid, "BookLists");
                  const docRef = doc(subcollectionRef, docID);
                  await updateDoc(docRef, {
                    visibility: 'private',
                  });
                  onClose();
                }
                catch(e){
                  console.error("Error updating book list visibility", e);
                }
            }
            else if (makeItPrivate === false) {
                const uid = user.uid;
                try{
                  const subcollectionRef = collection(db, "users", uid, "BookLists");
                  const docRef = doc(subcollectionRef, docID);
                  await updateDoc(docRef, {
                    visibility: 'public',
                  });
                  onClose();
                }
                catch(e){
                  console.error("Error updating book list visibility", e);
                }
            }


        }
        UpdateBookListVisibility();
    })
    return (
        <>
      <div className="flex items-center justify-center fixed top-0 left-0 right-0 bottom-0 bg-gradient-to-b from-maroon z-10">
        <div className="overlay-inner rounded-lg bg-lightcolor w-4/5 h-32 p-6 relative box-border overflow-hidden ring-1 ring-inset ring-gray-300 
        placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 "
        style={{ maxHeight: "90vh", overflowY: "auto" }}>
          <button className="close" onClick={onClose}>
            <FaRegTimesCircle />
          </button>
          {privacy === "public" ? (
            <>
            <h2 className="text-xl pb-5 text-maroon">Are you sure you want to make your booklist private?</h2>
            <div className="flex flex-row justify-center gap-10">
              <div><button className="bg-maroon hover:bg-lightmaroon p-2 px-4 rounded-full text-white" onClick={()=>{setMakePrivate(true)}}>Yes</button></div>
              <div><button className="bg-maroon hover:bg-lightmaroon p-2 px-4 rounded-full text-white">No</button></div>
            </div>
            </>
          ):(
            <>
            <h2 className="text-xl pb-5 text-maroon">Are you sure you want to make your booklist public?</h2>
            <div className="flex flex-row justify-center gap-10">
              <div><button className="bg-maroon hover:bg-lightmaroon p-2 px-4 rounded-full text-white" onClick={()=>{setMakePrivate(false)}}>Yes</button></div>
              <div><button className="bg-maroon hover:bg-lightmaroon p-2 px-4 rounded-full text-white">No</button></div>
            </div>
            </>
          )}
          
        </div>
      </div>
    </>
    );
}